document.addEventListener('DOMContentLoaded', function() {
  const productFeedTabs = document.querySelectorAll('promotional-featured-collection');

  productFeedTabs.forEach(feedTab => {
    const swiperAreas = feedTab.querySelectorAll('.promotional-featured-collection--slider');
    let swipers = [];

    function initSwiper() {

      swiperAreas.forEach((area, index) => {
        const container = area.querySelector('.promotional-featured-collection-swiper');

        if (!container.swiper) {
          const pagination = area.querySelector('.promotional-featured-collection-pagination');

          swipers[index] = new Swiper(container, {
            slidesPerView: 2.1,
            spaceBetween: 13,
            pagination: {
              el: pagination,
              clickable: true,
              type: "progressbar"
            },
            breakpoints: {
              990: {
                slidesPerView: 2.5,
                spaceBetween: 20,
              }
            }
          });
        }
      });
    }

    initSwiper();
  });
});
